import { render, staticRenderFns } from "./DataAudit.vue?vue&type=template&id=2f47df54&scoped=true"
import script from "./DataAudit.vue?vue&type=script&lang=js"
export * from "./DataAudit.vue?vue&type=script&lang=js"
import style0 from "./DataAudit.vue?vue&type=style&index=0&id=2f47df54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47df54",
  null
  
)

export default component.exports